import type { SellerForm as SellerFormValues } from '@gozoki/api'
import { useMutation } from '@tanstack/react-query'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { toast } from 'sonner'
import { SellerForm } from '~/components/routes/sellers/SellerForm'
import { api } from '~/lib/tuyau'
import { getAxiosErrorMessage } from '~/lib/utils'
import type { PermissionTuple } from '~/utils/ability'
import { usePermissionGuard, withRoutePermissions } from '~/utils/rbac'

const ADD_SELLER: PermissionTuple = ['add', 'sellers.sellers.seller']

export const Route = createFileRoute('/_authenticated/sellers/new')({
  staticData: {
    permission: ADD_SELLER,
  },
  component: AddSellerPage,
})
withRoutePermissions(Route)

const EMPTY_SELLER: SellerFormValues = {
  reference: '',
  label: '',
  address: '',
  addressAdditionnal: '',
  postalCode: '',
  city: '',
}

function AddSellerPage() {
  const navigate = useNavigate()
  const canAdd = usePermissionGuard(ADD_SELLER).authorized

  const { mutateAsync: create } = useMutation(api.sellers.store.mutationOptions({}))

  const navigateBack = () => navigate({ to: '/sellers/sellers' })

  return (
    <SellerForm
      title="Ajouter un vendeur"
      submitLabel="Ajouter"
      canEdit={canAdd}
      defaultValues={EMPTY_SELLER}
      onCancel={navigateBack}
      onSubmit={async (values) => {
        try {
          await create({ body: values })
          navigateBack()
        } catch (error) {
          toast.error(getAxiosErrorMessage(error))
        }
      }}
    />
  )
}
